import { render } from "./AddToWorkModal.vue?vue&type=template&id=76df4e28"
import script from "./AddToWorkModal.vue?vue&type=script&lang=js"
export * from "./AddToWorkModal.vue?vue&type=script&lang=js"

import "./AddToWorkModal.vue?vue&type=style&index=0&id=76df4e28&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__